export default "__VITE_ASSET__DNZ2sdTl__"